<template>
  <a
    href="#"
    :aria-controls="itemRef"
    aria-expanded="false"
    class="nav-link"
    v-bind="$attrs"
    type="button"
    @click="go()"
  >
    <div
      class="text-center bg-white shadow icon icon-sm border-radius-md d-flex align-items-center justify-content-center"
      :class="isRTL ? ' ms-2' : 'me-2'"
    >
      <slot name="icon"></slot>
    </div>
    <span
      class="nav-link-text nav-item-size"
      :class="isRTL ? ' me-1' : 'ms-1'"
      >{{ navText }}</span
    >
  </a>
</template>

<script>

  import { mapState } from "vuex";

  export default {
    name: "SidenavFolderItem",
    props: {
      itemRef: {
        type: String,
        required: true
      },
      navText: {
        type: String,
        required: true
      },
    },
  emits: ['switch'],
    computed: {
      ...mapState(["isRTL"]),
    },
    methods: {
      go() {
        this.$emit('switch', this.itemRef)
      }
    },
  };

</script>

<style lang="scss" scoped>

  .nav-item-size {
    font-size: 0.875rem !important;
  }

</style>
